import { Periodo } from './periodo.entity';
export class Factura {
  FacturaCodigo: number;
  PeriodoCodigo: string;
  ContratoCodigo: number;
  ContratoVersion: number;
  Version: number;
  SociedadCodigo: number;
  SerieCodigo: number;
  Numero: string;
  Fecha?: string;
  ClienteCodigo: number;
  SerieRectificativa: number;
  NumeroRectificativa: string;
  FechaFactRectificativa?: Date;
  LecturaAnterior: number;
  FechaLecturaAnterior: Date;
  LecturaLector: number;
  FechaLecturaLector: Date;
  LecturaInspector?: number;
  FechaLecturaInspector?: string;
  LecturaFactura: number;
  FechaLecturaFactura: string;
  ConsumoReal: number;
  ConsumoFactura: number;
  ConsumoComunitario?: number;
  ConsumoFinal?: number;
  Lote: number;
  LectorCodigoEmpleado: number;
  LectorCodigoContratista: number;
  InspectorCodigoEmpleado: number;
  InspectorCodigoContratista: number;
  NumeroRemesa: number;
  FechaRemesa: string;
  ZonaCodigo: string;
  Inspeccion?: number;
  LectorIncidenciaLectura?: string;
  InspectorIncidenciaLectura?: string;
  FechaRegistro: string;
  OTSerieCodigo?: number;
  OTNumero?: number;
  FechaContabilizacion?: Date;
  FechaContabilizacionAnulada?: Date;
  UsuarioContabilizacion?: string;
  UsuarioRegistro?: string;
  UsuarioContabilizacionAnulada?: string;
  RazRectcod: string;
  RazRectDescType: string;
  MeRect: string;
  MeRectType: string;
  TipoRect: string;
  EnvSERES: string;
  EnvioSAP: boolean;
  LineasDetalladas?: any;
  LineasAgrupadasPorImpuesto?: any;
  FacturaRectificativa?: Factura;
  FacturaRectificada?: Factura;
  Periodo?: Periodo;
  Contrato?: any;
  Serie?: any;
  Sociedad?: any;
  Cliente?: any;
  Lector?: any;
  Inspector?: any;
  Zona?: any;
  Perzonalote?: any;
  TotalFacturado?: number;
  TotalCobrado?: number;
  LineasFactura?: any;
  CobrosFactura?: any;
  Cobrada: boolean = (this.Fecha === null || this.TotalCobrado >= this.TotalFacturado);
  Estado: number;

  Identificador: string;
}
